import React from 'react';
import data from '../../ourDoctors.json';

const { doctorsList } = data;

const DoctorsList = () => {
  const { id, heading, items } = doctorsList;

  return (
    <section id={id} className="w-full bg-white pb-12">
      <div className="container mx-auto px-4 md:px-8">

        {/* ── Heading ── */}
        <h2
          className="text-center ava-heading-lg mb-10 md:mb-12"
        >
          {heading}
        </h2>

        {/* ── Doctor Cards ── */}
        <div className="flex flex-col gap-5 md:gap-6 max-w-4xl mx-auto">
          {items.map((doctor) => (
            <DoctorCard key={doctor.id} doctor={doctor} />
          ))}
        </div>

      </div>
    </section>
  );
};

/* ── Individual Doctor Card ── */
const DoctorCard = ({ doctor }) => (
  <div
    className="flex flex-col sm:flex-row rounded-2xl overflow-hidden ava-card-bg"
  >
    {/* ── Left: Doctor photo ── */}
    <div
      // className="relative flex-shrink-0"
      // className="relative w-full sm:w-[260px] md:w-[280px] flex-shrink-0"
      className="relative w-full sm:w-[220px] md:w-[260px] lg:w-[280px] h-[220px] flex items-center justify-center  sm:h-auto flex-shrink-0"
      style={{ width: '100%', maxWidth: '280px', minHeight: '300px' }}
    >
      <img
        src={doctor.image}
        alt={doctor.name}
        className="w-full h-full object-cover object-top"
        // className="flex flex-col justify-center gap-3  flex-1 h-full object-center "
        // style={{ minHeight: '280px' }}
        draggable={false}
      />
      {/* Name overlay — bottom of photo */}
      <div
        className="absolute bottom-0 left-0 right-0 px-4 py-3"
        style={{
          background:
            'linear-gradient(to top, rgba(10,20,80,0.75) 0%, transparent 100%)',
        }}
      >
        <p className="text-white ava-text-subheading">
          {doctor.name}
        </p>
      </div>
    </div>

    {/* ── Right: Doctor details ── */}
    <div className="flex flex-col justify-center gap-3 px-5 py-6 md:px-8 md:py-7 flex-1">

      {/* Designation */}
      <p
        className="ava-text-subheading"
      >
        {doctor.designation}
      </p>
      {/* Location */}
      {doctor.location && (
        <div className="flex items-center gap-1.5">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="text-[var(--ava-primary)] shrink-0"
            aria-hidden="true"
          >
            <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" />
            <circle cx="12" cy="10" r="3" />
          </svg>

          <p className="ava-text-body text-gray-600">
            {doctor.location}
          </p>
        </div>
      )}
      {/* Experience */}
      <p
        className="ava-text-body"
      >
        <span className="font-semibold">Experience:</span>{' '}
        <span>{doctor.experience}</span>
      </p>

      {/* Bio */}
      <p
        className="ava-text-body"
      >
        {doctor.bio}
      </p>

      {/* Specializations */}
      {doctor.specializations && doctor.specializations.length > 0 && (
        <p
          className="ava-text-body"
        >
          <span className="font-semibold">Specializations: </span>
          {doctor.specializations.map((spec, i) => (
            <React.Fragment key={i}>
              <span>{spec}</span>
              {i < doctor.specializations.length - 1 && (
                <span className="mx-1.5 ">|</span>
              )}
            </React.Fragment>
          ))}
        </p>
      )}

      {/* Book button */}
      <div className="mt-1">
        <a
          href={doctor.bookingHref || '#book'}
          className="btn-primary"
        // style={{ padding: '0.55rem 1.5rem' }}
        >
          {doctor.bookingLabel || 'Book an Appointment'}
        </a>
      </div>

    </div>
  </div>
);

export default DoctorsList;